module.exports = __webpack_public_path__ + "img/layer.75e57eda.png";